<template>
    <div class="mt-card-item deal-card"
         @click="selectDeal">
        <div class="mt-card-avatar mt-overlay-1">
            <img :src="img + '?w=300'">
            <div class="mt-overlay">
                <ul class="mt-info">
                    <li>
                        <a class="btn default btn-outline" href="javascript:;">
                            <i class="icon-chart"></i>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="mt-card-content">
            <h3 class="mt-card-name" v-html="title"></h3>
            <div class="mt-card-desc font-grey-mint" v-html="$options.filters.md(description)"></div>
            <div class="mt-card-footer">
                <button class="btn btn-block btn-outline" :class="btnClass">{{ $t(`deals.${status}`) }}</button>
            </div>
        </div>
    </div>
</template>
<script>
  /* ============
   * DealCard Component
   * ============
   *
   */
  import * as appMutations from '@/app/store/modules/app/mutation-types'

  export default {
    props: {
      dealId: {
        type: String,
        required: true
      },
      img: {
        type: String,
        required: true
      },
      title: {
        type: String,
        required: true
      },
      description: {
        type: String,
        required: true
      },
      status: {
        type: String,
        required: true
      },
      dealData: {
        type: Object,
        required: true
      }
    },
    computed: {
      btnClass () {
        let btnClass = 'blue'
        switch (this.status) {
          case 'STATUS_ACTIVE':
            btnClass = 'green'
            break
          case 'STATUS_ENDED':
            btnClass = 'red'
            break
          default:
            btnClass = 'blue'
        }

        return [btnClass]
      }
    },
    methods: {
      selectDeal () {
        this.$store.commit(`app/${appMutations.SELECTED_DEAL}`, this.dealData)
        this.$router.push({name: 'clo.deal.stats', params: {locale: this.$i18n.locale, offerId: this.dealId}})
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/components/DealCard.vue